<template>
  <div>
    <h3>Approved Students</h3>

    <b-form inline @submit.prevent="" class="mb-2">
      <label for="terms">Term</label>
      <b-form-select id="terms" @input="changeTerm" v-model="term" :options="terms" value-field="termId" text-field="description">
        <template slot="first">
          <!-- this slot appears above the options from 'options' prop -->
          <option :value="null">None</option>
        </template>
      </b-form-select>

      <label for="types">Type</label>
      <b-form-select id="types" v-model="opportunityTypeId" :options="opportunityTypes" value-field="opportunityTypeId" text-field="name">
        <template slot="first">
          <!-- this slot appears above the options from 'options' prop -->
          <option :value="null">All</option>
        </template>
      </b-form-select>

      <label for="categories">Category</label>
      <b-form-select id="categories" v-model="opportunityCategoryId" :options="validCategoryOptions" value-field="opportunityCategoryId" text-field="name">
        <template slot="first">
          <!-- this slot appears above the options from 'options' prop -->
          <option :value="null">All</option>
        </template>
      </b-form-select>

      <label for="courses">Course</label>
      <b-form-select id="courses" v-model="course" :options="courses" value-field="displayName" text-field="displayName">
        <template slot="first">
          <!-- this slot appears above the options from 'options' prop -->
          <option :value="null">All</option>
        </template>
      </b-form-select>

      <b-input-group class="filter-group ml-2" >
        <b-input-group-prepend is-text>
            <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
        <b-input-group-append>
            <b-button @click="filter = null">Clear</b-button>
        </b-input-group-append>
      </b-input-group>      
    </b-form>

    

    <b-table striped
          hover
          :items="studentOpportunities"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filterItems"
          @filtered="onFiltered"
          responsive
          :sort-compare="customSort">
      <template slot="course" slot-scope="data">
        <div v-if="data.item.studentView">
          <p v-for="course in data.item.studentView.studentCourses" :key="course.classSid">
            {{ course.subjectCode }} {{ course.catalogNumber }} ( {{ course.unitsTaken }} credits )
          </p>
        </div>
      </template>
      <template slot="site" slot-scope="data">
        <div v-if="data.item.opportunity.site">
          <strong>{{ data.item.opportunity.site.name }}</strong><br/>
          {{ data.item.otherAddress }}
        </div>
      </template>
      <template slot="type" slot-scope="data">
        {{ data.item.opportunity.opportunityType.name}} ( {{ data.item.opportunity.opportunityCategory.name }} )
      </template>
      <template slot="contacts" slot-scope="data">
        <div v-if="data.item.studentOpportunityContacts">
          <p v-for="contact in data.item.studentOpportunityContacts" :key="contact.studentOpportunityContactId">
            <strong>{{ contact.siteContact.firstName }} {{ contact.siteContact.lastName }}</strong><br/> 
            <a :href="mailTo(contact.siteContact.email)">{{ contact.siteContact.email }}</a>
          </p>   
        </div>    
      </template>
      <template slot="details" slot-scope="data">
        <router-link :to="{ name: 'studentOpportunityDetails', params: { studentOpportunityId: data.item.studentOpportunityId } }">View</router-link> 
      </template>
    </b-table>

    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import terms from "../../api/terms";
import opportunities from "../../api/opportunity";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      fields: [
        { key: "studentView.lastName", label: "Last Name", sortable: true },
        { key: "studentView.firstName", label: "First Name", sortable: true },
        { key: "course", sortable: true },
        { key: "type", sortable: true, label: "Type / Category" },
        { key: "site", label: "Site", sortable: true },
        { key: "contacts", sortable: false },
        { key: "details", sortable: false }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      term: null,
      terms: [],
      opportunityTypeId: null,
      opportunityCategoryId: null,
      opportunityCategories: [],
      course: null,
      courses: []
    };
  },

  computed: {
    ...mapState({
      studentOpportunities: state =>
        state.studentOpportunities.studentOpportunities,
      opportunityTypes: state => state.studentOpportunities.opportunityTypes
    }),
    validCategoryOptions: function() {
      var that = this;
      if (this.opportunityTypeId) {
        return _.filter(this.opportunityCategories, function(category) {
          return _.find(category.opportunityTypeOpportunityCategories, function(
            opportunityTypeOpportunityCategory
          ) {
            return (
              opportunityTypeOpportunityCategory.opportunityTypeId ===
              that.opportunityTypeId
            );
          });
        });
      }
      return this.opportunityCategories;
    }
  },

  methods: {
    ...mapActions("studentOpportunities", [
      "getApprovedStudentOpportunities",
      "getOpportunityTypes"
    ]),
    mailTo(email) {
      return "mailto:" + email;
    },
    changeTerm() {
      this.getApprovedStudentOpportunities(this.term);
    },

    filterItems(item) {
      var matchedTerm = this.matchTerm(item, this.term);
      var matchedType = this.matchType(item, this.opportunityTypeId);
      var matchedCategory = this.matchCategory(
        item,
        this.opportunityCategoryId
      );
      var matchedCourse = this.matchCourse(item, this.course);
      var matchedFilter = this.matchFilter(item, this.filter);

      if (
        matchedTerm &&
        matchedType &&
        matchedCategory &&
        matchedCourse &&
        matchedFilter
      ) {
        return true;
      }
      return false;
    },
    matchTerm(item, term) {
      if (item.opportunity.term.termId === term || term === null) {
        return true;
      }
      return false;
    },
    matchType(item, opportunityTypeId) {
      if (
        opportunityTypeId === null ||
        item.opportunity.opportunityType.opportunityTypeId === opportunityTypeId
      ) {
        return true;
      }
      return false;
    },
    matchCategory(item, opportunityCategoryId) {
      if (
        opportunityCategoryId === null ||
        item.opportunity.opportunityCategory.opportunityCategoryId ===
          opportunityCategoryId
      ) {
        return true;
      }
      return false;
    },
    matchCourse(item, course) {
      if (
        course === null ||
        (item.studentView &&
          _.filter(item.studentView.studentCourses, studentCourse => {
            return (
              course ===
              studentCourse.subjectCode + " " + studentCourse.catalogNumber
            );
          }).length)
      ) {
        return true;
      }
      return false;
    },
    matchFilter(item, filter) {
      if (filter != "" && filter != null) {
        var found = this.search([item], this.filter);
        return found.length > 0;
      }
      return true;
    },
    search(collection, text) {
      var that = this;
      return _.filter(collection, function(object) {
        var search = that.deepSearch(object, text.toLowerCase());
        return _.keys(search).length > 0;
      });
    },
    deepSearch(collection, predicate, thisArg) {
      if (_.isFunction(predicate)) {
        predicate = _.iteratee(predicate, thisArg);
      } else {
        var keys = _.flatten(_.tail(arguments));
        if (typeof keys === "string") {
          keys = keys.toLowerCase();
        }
        predicate = function(val, key) {
          if (typeof val === "string") {
            val = val.toLowerCase();
          }
          return _.includes(val, keys);
        };
      }
      var that = this;
      return _.transform(collection, function(memo, val, key) {
        var include = predicate(val, key);
        if (!include && _.isObject(val)) {
          val = that.deepSearch(val, predicate);
          include = !_.isEmpty(val);
        }
        if (include) {
          _.isArray(collection) ? memo.push(val) : (memo[key] = val);
        }
      });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    customSort(a, b, key) {
      if (key === "opportunity.name") {
        return a.opportunity.name.localeCompare(b.opportunity.name);
      } else if (key === "student.lastName") {
        return a.student.lastName.localeCompare(b.student.lastName, undefined, {
          numeric: true
        });
      } else if (key === "student.firstName") {
        return a.student.firstName.localeCompare(
          b.student.firstName,
          undefined,
          { numeric: true }
        );
      } else if (key === "category") {
        var categoryNameA = a.opportunity.opportunityCategory
          ? a.opportunity.opportunityCategory.name
          : "";
        var categoryNameB = b.opportunity.opportunityCategory
          ? b.opportunity.opportunityCategory.name
          : "";
        return categoryNameA.localeCompare(categoryNameB, undefined, {
          numeric: true
        });
      } else if (key === "type") {
        var typeNameA = a.opportunity.opportunityType
          ? a.opportunity.opportunityType.name
          : "";
        var typeNameB = b.opportunity.opportunityType
          ? b.opportunity.opportunityType.name
          : "";
        return typeNameA.localeCompare(typeNameB, undefined, { numeric: true });
      } else if (key === "opportunity.site.name") {
        return a.opportunity.site.name.localeCompare(
          b.opportunity.site.name,
          undefined,
          { numeric: true }
        );
      } else if (key === "opportunity.term.description") {
        return a.opportunity.term.termCode < b.opportunity.term.termCode
          ? -1
          : a.opportunity.term.termCode > b.opportunity.term.termCode
            ? 1
            : 0;
      }
      return null;
    }
  },

  // watch: {
  //   terms: function() {
  //     if (this.term === null) {
  //       this.term = this.terms[0].termId;
  //     }
  //   }
  // },
  created() {
    if (this.term) {
      this.getApprovedStudentOpportunities(this.term);
    }
    terms.getTerms().then(response => {
      this.terms = response.data;
    });
    opportunities.getInternshipCourses().then(response => {
      this.courses = response.data;
    });
    opportunities.getOpportunityCategories().then(response => {
      this.opportunityCategories = response.data;
    });
    this.getOpportunityTypes();
  }
};
</script>

<style scoped>
.green {
  color: green;
}

.red {
  color: red;
}

.orange {
  color: orange;
}

.main-container {
  max-width: 100%;
  margin-top: 10px;
}
.widget-body {
  max-width: 100%;
}
/* .filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
} */

.new-content-button {
  margin-left: 10px;
}

label {
  font-weight: bold;
  margin: 0 0.3em 0 1.5em;
}

.clickable {
  cursor: pointer;
}

.sort-label {
  margin-right: 0.5em;
}

.loading-div {
  text-align: center;
  font-size: 2em;
}
</style>
